import {DeleteBoxInAdminDashboardSetting} from "../../../Assets/svg";
import React, {useState} from "react";

const BoxSectionInSettingAdminDashboard = (props) => {

  const [showBtn, setShowBtn] = useState(false);
  // const displayDeleteBtn = (event) => event.target.lastChild.classList.toggle('d-none');
  return (
    <div className={""}>
      <div
        onMouseOver={() => setShowBtn(true)}
        onMouseLeave={() => setShowBtn(false)}
        className={
          props.hasError ?
            "adminDashboardBox position-relative  mx-1 my-1 d-flex justify-content-center align-items-center border border-danger" :
            "adminDashboardBox position-relative  mx-1 my-1 d-flex justify-content-center align-items-center"
        }
      >
        <div>
          {props.titleShow === "" ?
            <div onClick={props.addTitleConfig} className={"inputInSettingBox"}>تکمیل اطلاعات</div>
            :
            <div className={"inputInSettingBoxTitleShow"}>{props.titleShow}</div>
          }

        </div>
        {showBtn && <div className={"deleteBoxInAdminDashboardSetting"}
                         onClick={props.deleteBox}
        >
          <DeleteBoxInAdminDashboardSetting/>
        </div>}
      </div>
    </div>

  )
}
export default BoxSectionInSettingAdminDashboard;
